import { ActivatedRouteSnapshot } from '@angular/router';
import { submissionTypesTokenizer } from '../store';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { CONFIGURE_DEFAULT_PARAMS } from '@data-access/downloads-exports';
import { inject } from '@angular/core';
import { LoadGridPayload } from '@data-access/shared/types/base-grid.type';

export const submissionTypesResolver = (route: ActivatedRouteSnapshot) => {
  const _submissionTypesAdminTokenizer = submissionTypesTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);
  const _params = _wcgTableUtils.generateTableQueryParams(
    CONFIGURE_DEFAULT_PARAMS(route),
  );
  const _payload: LoadGridPayload = {
    params: _params,
  };
  _submissionTypesAdminTokenizer.loadIrisRoutingGroups();
  _submissionTypesAdminTokenizer.loadWorkspaceSubTypes(_payload);
  return !!_submissionTypesAdminTokenizer.$workspaceSubTypes();
};
